import { writable } from "svelte/store";

export const rawCalculatorData = writable(null);
export const rawCopy = writable(null);
